import React, { useEffect, useMemo, useState } from 'react'
import { SafeAreaView, ScrollView } from 'react-native'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { CustomHeader } from '../../components/CustomHeader'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { GenericInfoScreenContext } from './constants'
import { AboutBrio } from './components/AboutBrio'
import { PlainInfoComponent } from './components/PlainInfoComponent'
import { TermsOfUse } from '../../components/terms-of-use/TermsOfUse'
import { isWeb } from '../../utils/isWeb'

export const GenericInfoScreen: NavigationStackScreenComponent = navigation => {
  // @ts-ignore
  const context = useMemo(() => navigation.route.params.context, [navigation]) as GenericInfoScreenContext

  const [screenContext, setScreenContext] = useState<GenericInfoScreenContext>(GenericInfoScreenContext.ABOUT)

  useEffect(() => {
    setScreenContext(context)
  }, [context])

  const render = () => {
    switch (screenContext) {
      case GenericInfoScreenContext.ABOUT:
        return <AboutBrio />
      case GenericInfoScreenContext.PRIVACY_POLICY:
        return <PlainInfoComponent context={screenContext} />
      case GenericInfoScreenContext.USE_TERMS:
        return <TermsOfUse />
    }
  }

  if (isWeb()) {
    return render()
  }

  return (
    <SafeAreaView>
      <ScrollView>{render()}</ScrollView>
    </SafeAreaView>
  )
}

GenericInfoScreen.navigationOptions = CustomHeader('', true, () => Coordinator.goBack())
